import ComicCard from '@/components/base/ComicCard';
import type { Comic } from '@/mocks/types';

interface HotRecommendSectionProps {
  comics: Comic[];
}

export default function HotRecommendSection({ comics }: HotRecommendSectionProps) {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 8);

  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20">
      <div className="w-full max-w-[1280px] mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              热门推荐
            </h2>
          </div>
          <span className="text-sm text-foreground-500 whitespace-nowrap">本周最受欢迎韩漫</span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {hotComics.map((comic) => (
            <ComicCard key={comic.id} comic={comic} showRank />
          ))}
        </div>
      </div>
    </section>
  );
}